import { render, staticRenderFns } from "./FirmInfo.vue?vue&type=template&id=06a4f6a9"
import script from "./FirmInfo.vue?vue&type=script&lang=js"
export * from "./FirmInfo.vue?vue&type=script&lang=js"
import style0 from "./FirmInfo.vue?vue&type=style&index=0&id=06a4f6a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports